import React, { useMemo, useState, type ReactNode } from 'react';
import Button from '@atlaskit/button';
import { Box, xcss } from '@atlaskit/primitives';
import { useIntl } from '@atlassian/jira-intl';

import type { SupportedThirdParty } from '../../../common/constants/import-type';
import { SectionHeading } from '../../../common/ui';
import { useContentForThirdParty, useUrlForThirdParty } from '../../../common/utils';
import { StatusMappingEntityContext } from '../../../common/utils/status-mapping-entity-context';
import { useThirdPartyState } from '../../../controllers/import-state';
import messages from './messages';
import { StatusMappingContent } from './status-mapping-content';

type Props = {
	thirdParty: SupportedThirdParty;
};
export const StatusMapping = ({ thirdParty }: Props) => {
	const { formatMessage } = useIntl();
	const [{ thirdPartyStatusMapping }] = useThirdPartyState();
	const entities = useMemo(
		() => Object.keys(thirdPartyStatusMapping?.entityStatusMappings ?? {}),
		[thirdPartyStatusMapping?.entityStatusMappings],
	);
	const defaultEntity = (entities && entities.length > 0 && entities[0]) || null;
	const [selectedEntityTab, setselectedEntityTab] = useState<string | null>(defaultEntity);
	const { statusMappingDescription } = useContentForThirdParty(thirdParty);
	const { statusMappingURL } = useUrlForThirdParty(thirdParty);

	return (
		<StatusMappingEntityContext.Provider value={selectedEntityTab}>
			<Box
				xcss={contentWrapperStyles}
				testId="project-create-importer-upload-flow.ui.third-party-review-screen.status-mapping.wrapper"
			>
				<SectionHeading>{formatMessage(messages.heading)}</SectionHeading>
				<Box paddingBlockStart="space.200" paddingBlockEnd="space.300">
					{statusMappingDescription &&
						formatMessage(statusMappingDescription, {
							link: (chunks: ReactNode[]) => (
								<Button href={statusMappingURL} target="_blank" appearance="link" spacing="none">
									{chunks}
								</Button>
							),
						})}
				</Box>
				<StatusMappingContent
					thirdParty={thirdParty}
					onEntityChanged={(entity: string) => {
						setselectedEntityTab(entity);
					}}
					entities={entities ?? []}
					selectedEntityTab={selectedEntityTab}
				/>
			</Box>
		</StatusMappingEntityContext.Provider>
	);
};

const contentWrapperStyles = xcss({
	width: '560px',
	paddingTop: 'space.300',
});
